<template>
  <div id="contenedor-ejecucion-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Estimaciones">
            <template v-slot:opciones-derecha>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="mostrarVentanaExcelEstimaciones = !mostrarVentanaExcelEstimaciones">
                    <v-icon> mdi-file-excel </v-icon>
                  </v-btn>
                </template>
                <span> Exportar Estimaciones </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'contratosEstimacionesEstadisticas' }">
                    <v-icon>mdi-poll</v-icon>
                  </v-btn>
                </template>
                <span>Estadisticas</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'ejecuccionConfiguracionFirmas' }">
                    <v-icon>mdi-cog-outline</v-icon>
                  </v-btn>
                </template>
                <span>Configuracion</span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :filtros="filtros"
            :listaContratos="getContratos">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listadoContratos="getListadoDeContratos">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarVentanaExcelEstimaciones"
      v-model="mostrarVentanaExcelEstimaciones"
      width="400">
      <excel-estimaciones-ejercicio
      :filtros="filtros"
      :contratos="getContratos"
      v-on:cerrar="mostrarVentanaExcelEstimaciones = !mostrarVentanaExcelEstimaciones">
      </excel-estimaciones-ejercicio>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosEstimaciones.gql';
import ExcelEstimacionesEjercicio from '@/components/exportar/exceles/ExcelEstimacionesEjercicio.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'EjecucionDefault',
  components: {
    ExcelEstimacionesEjercicio,
    TituloToolBar,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaExcelEstimaciones: false,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
        tipoEstimacion: null,
      },
    };
  },
  mounted() {
    // Checar si hay filtros guardados.
    const filtrosGuardados = JSON.parse(this.mixGetFiltro('filtros-estimaciones'));
    if (filtrosGuardados) {
      this.filtros = JSON.parse(this.mixGetFiltro('filtros-estimaciones'));
    }
  },
  methods: {
    setFiltros(filtros) {
      this.filtros = filtros;
    },
  },
  apollo: {
    contratosByEjercicio: {
      query: CONTRATOS,
      variables() {
        let ejercicio = new Date().getFullYear();
        let periodo = 1;

        if (typeof this.filtros.ejercicio === 'string') {
          const split = this.filtros.ejercicio.split('-');
          ejercicio = Number(split[0]);
          periodo = Number(split[1]);
        } else {
          ejercicio = Number(this.filtros.ejercicio);
        }
        return ({
          ejercicio,
          periodo,
        });
      },
    },
  },
  computed: {
    getContratos() {
      if (!this.contratosByEjercicio) return [];
      return this.contratosByEjercicio// Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    getListadoDeContratos() {
      if (!this.contratosByEjercicio) return [];
      return this.contratosByEjercicio
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        // Filtro por tipo de estimaciones
        .filter(({ estimaciones }) => {
          if (!this.filtros.tipoEstimacion) return true;

          if (this.filtros.tipoEstimacion === 1) {
            return estimaciones.some(
              ({ esEstimacionFiniquito }) => esEstimacionFiniquito === true,
            );
          }
          if (this.filtros.tipoEstimacion === 2) {
            if (estimaciones.length <= 0) return false;
            return estimaciones.every(
              ({ esEstimacionFiniquito }) => esEstimacionFiniquito === false,
            );
          }

          return estimaciones.length === 0;
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .map((contrato) => ({
          ...contrato,
          cantidadEstimaciones: Number(contrato.estimaciones.length),
        }));
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('filtros-estimaciones', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('filtros-estimaciones');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
</style>
